import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class LineSpaceTransform extends EldmlTransform {
  apply() {
    this.selector.find("[line-space]").each(function () {
      $(this).attr(
        "style",
        ($(this).attr("style") ? $(this).attr("style") : "") +
          "line-height: calc(1em + " +
          $(this).attr("line-space") +
          ");",
      );
    });
  }
}
